module.exports = __webpack_public_path__ + "static/media/qiskit_logo.9b4fffed.jpg";